import React from 'react';
import { useFirebaseAuth } from '../hooks/useFirebaseAuth';
import { useSessionExpiryManager } from '../hooks/useSessionExpiryManager';
import SessionExpiryModal from './SessionExpiryModal';

interface SessionWrapperProps {
  children: React.ReactNode;
}

const SessionWrapper: React.FC<SessionWrapperProps> = ({ children }) => {
  const { user } = useFirebaseAuth();
  const {
    showModal,
    timeLeft,
    isExpired,
    refreshSession,
    logout
  } = useSessionExpiryManager();

  return (
    <>
      {children}
      
      {/* Only show modal if user is logged in */}
      {user && (
        <SessionExpiryModal
          open={showModal}
          timeLeft={timeLeft}
          isExpired={isExpired}
          onRefresh={refreshSession}
          onLogout={logout}
        />
      )}      
    </>
  );
};

export default SessionWrapper; 